module.exports = "https://static.wagwalking.com/_next/static/images/desktop-placeholder-7c6800c8fb057ed37773df85ac515d74.jpg";